export interface FullPageRedirectState {
  params: URLSearchParams;
  redirectTo?: string;
  decodedState: any;
}

export const fullPageRedirectState = new Promise<FullPageRedirectState>((resolve, reject) => {
  const params = new URLSearchParams(window.location.search);
  const redirectTo = params.get("redirectTo");
  const b64state = params.get("state");
  // TODO: the below breaks login with email, firebase auth params need to be handled explicitly
  // if (params.size > 0) {
  //   // If there are any full page redirect params, remove them from the url
  //   window.history.replaceState(null, "", window.location.pathname);
  // }
  if (b64state) {
    try {
      const state = JSON.parse(atob(b64state));
      if ("redirectTo" in state) {
        resolve({
          params: params,
          redirectTo: state.redirectTo,
          decodedState: state,
        });
      } else {
        resolve({
          params: params,
          redirectTo: redirectTo ?? undefined,
          decodedState: undefined,
        });
      }
    } catch {
      resolve({
        params: params,
        redirectTo: redirectTo ?? undefined,
        decodedState: undefined,
      });
    }
  }
});

export function encodeFullPageRedirectState(redirectTo: string, data: any): string {
  const json = JSON.stringify({ redirectTo: redirectTo, ...data });
  console.log(json);
  const encoded = btoa(json);
  console.log(encoded);
  // TODO: check length?
  return encoded;
}
